import type { CustomIconProps } from '../types';

const Plus = ({ width, height, color }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill={color ?? 'none'}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 0.5C6.5 0.223858 6.27614 0 6 0C5.72386 0 5.5 0.223858 5.5 0.5V5.5L0.5 5.5C0.223858 5.5 0 5.72386 0 6C0 6.27614 0.223858 6.5 0.5 6.5L5.5 6.5V11.5C5.5 11.7761 5.72386 12 6 12C6.27614 12 6.5 11.7761 6.5 11.5V6.5L11.5 6.5C11.7761 6.5 12 6.27614 12 6C12 5.72386 11.7761 5.5 11.5 5.5L6.5 5.5V0.5Z"
            fill={color ?? '#414042'}
        />
    </svg>
);

export default Plus;
